export default __webpack_public_path__ + "static/media/uploader-dexcom-3.f444713a.png";